export default {"src":"/_next/static/media/discord.ba6cb3bf.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};